/**
 * Chaves de SKU LEGADAS — espelho EXATO de `LEGACY_DECODED_SKU_KEYS` do backend
 * (`backend_v2/src/core/utils/identifiers.js`).
 *
 * Até 2026-09-25 o `NormalizeSku` fazia `decodeURIComponent`, então o código
 * literal do Bling/ML (`40X40T%30`) virava outra chave (`40X40T0`) — e é essa
 * forma decodificada que está gravada em `products.sku`, vendas, saldo e RMA.
 * O decode saiu; este mapa congelado faz as 9 chaves antigas continuarem
 * casando sem decodificar nenhum SKU novo.
 *
 * Remover as entradas NA MESMA JANELA do rename dos SKUs (back e front juntos).
 */
export const LEGACY_DECODED_SKU_KEYS = Object.freeze(
    new Map([
        ['40X40T%30', '40X40T0'],
        ['40X40T%10', '40X40T\u0010'],
        ['40X40T21M%30', '40X40T21M0'],
        ['40X40T21M%40', '40X40T21M@'],
        ['40X40T21M%60', '40X40T21M`'],
        ['AWR1-110X74%24', 'AWR1-110X74$'],
        ['AWR1-110X74%12', 'AWR1-110X74\u0012'],
        ['100X150T27M%10', '100X150T27M\u0010'],
        ['SHGPGMTGAA85G%18', 'SHGPGMTGAA85G\u0018'],
    ]),
);
